<template>
  <div class="bg-gray-600">
    <div class="upload videouploadLoader">
      <div
        class="w-full text-center mx-auto"
        :style="{
          display: !displayUploadbox ? 'inline-block' : 'none',
        }"
      >
        <div v-if="!video.video_source">
          <div class="mb-2 w-full text-grey-900">
            <div class="w-full font-semibold text-left title">
              {{ $t('frontend_groovevideo_videos_step1_title') }}
            </div>
            <div class="w-full text-sm h-12 text-left">
              <text-input
                v-model="video.name"
                :validator="$v.video.name"
                value="video.name"
                attribute="Name"
                :placeholder="$t('frontend_groovevideo_videos_step1_name')"
              />
            </div>
          </div>
          <div class="mb-2 w-full text-grey-900">
            <div class="w-full font-semibold text-left title">Category</div>
            <div class="w-full text-sm text-left">
              <div>
                <gd-dropdown
                  :options="categories"
                  v-model="video.category_id"
                  :validator="$v.video.category_id"
                  value="video.category_id"
                  class="text-left"
                  placeholder="Select Category"
                  size="full"
                ></gd-dropdown>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="
            w-24
            h-24
            rounded-full
            bg-grey-300
            flex
            items-center
            justify-center
            m-auto
          "
        >
          <img src="../assets/images/videos/upload.png" alt />
        </div> -->
        <h3 class="mt-6 mb-2 dropzone-custom-title text-grey-900">
          {{ $t('frontend_groovevideo_videos_fileupload_drag') }}
        </h3>
        <gd-tabs
          :tabs="uploadTabs"
          :currentTab="currentTab"
          :disableNotCompleted="true"
          :wrapper-class="'px-0 gs-default-tabs'"
          :tab-active-class="'border-pink border-b-2 text-pink gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
          class="uploadTab"
          :key="this.$t('frontend_groovevideo_videos_fileupload_mycomputer')"
        />
        <div class="fill-w">
          <div class="py-4 px-2" v-if="currentTab === 'step1'">

            <vue-dropzone
              v-if="canUploadVideos && temporaryBucket"
              id="customdropzone"
              ref="myVueDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              :awss3="awss3"
              @vdropzone-s3-upload-error="s3UploadError"
              @vdropzone-s3-upload-success="s3UploadSuccess"
              @vdropzone-upload-progress="uploadProgress"
              @vdropzone-total-upload-progress="totalProgress"
              @vdropzone-file-added="fileAdded"
            > 
              <div class="dropzone-custom-content">
                <!-- <div
                  class="w-24 h-24 rounded-full bg-grey-300 flex items-center justify-center m-auto"
                >
                  <img src="../assets/images/videos/upload.png" alt />
                </div>
                <h3 class="mt-6 mb-2 dropzone-custom-title">
                  Drag and drop video files to upload
                </h3> -->
                <p class="text-sm text-grey mb-4">
                  {{ $t('frontend_groovevideo_videos_fileupload_upload') }}
                </p>
                <div
                  class="
                    border-dashed
                    rounded-lg
                    bgcolor
                    border-grey-100 border
                    flex flex-col
                    h-40
                    justify-center
                    items-center
                    px-4
                  "
                >
                  <div class="text-xs subtitle mb-3">
                    {{ $t('frontend_groovevideo_videos_fileupload_drag_drop') }}
                    <br />
                    {{ $t('frontend_groovevideo_videos_fileupload_or') }}
                  </div>
                  <div
                    class="
                      w-full
                      flex flex-row flex-nowrap
                      items-center
                      justify-center
                    "
                  >
                    <gd-button primary class="px-4 w-auto mr-2">
                      {{ $t('frontend_groovevideo_videos_selectfile') }}
                    </gd-button>
                  </div>
                  <div
                    class="
                      p-2
                      flex flex-row flex-nowrap
                      items-center
                      justify-center
                      text-xs
                      subtitle
                      text-pink
                    "
                  >
                    {{ $t('frontend_groovevideo_video_size_limit') }}
                  </div>
                </div>
              </div>
            </vue-dropzone>


            <div class="flex flex-col items-center justify-center p-4" v-else-if="!canUploadVideos">
              <gd-button primary class="px-4 h-10 w-auto uppercase font-bold tracking-wide bg-green-extra-dark border-green-extra-dark hover:bg-green-dark hover:border-green-dark" @click="openUpgradeModal">
                {{ $t('frontend_groovevideo_videos_upgrade_pro') }}
              </gd-button>
            </div>

            <div 
              v-else-if="!temporaryBucket"
              class="text-sm font-semibold text-red mb-4"
            >
              <div v-if="!fetchingTempBucket">
                <span class="mr-2"><i class="fas fa-info-circle"></i></span>
                {{ $t('frontend_groovevideo_videos_no_temp_bucket') }}
              </div>
              <div v-else>
                {{ $t('frontend_groovevideo_videos_creating_temp_bucket') }}...
              </div>
            </div>
          </div>
          <div class="py-4 px-2" v-if="currentTab === 'step2'">
            <text-input
              v-model="model.youtubeUrl"
              :validator="$v.model.youtubeUrl"
              value="model.youtubeUrl"
              attribute="youtubeUrl"
              :placeholder="$t('frontend_groovevideo_videos_eg_youtube')"
            />
            <gd-button
              size="auto"
              class="py-4 mt-6 px-8 mr-2"
              @click="youtubeVideoLink"
            >
              {{ $t('frontend_save') }}
            </gd-button>
          </div>
          <div class="py-4 px-2" v-if="currentTab === 'step3'">
            <text-input
              v-model="model.mp4Url"
              :validator="$v.model.mp4Url"
              value="model.mp4Url"
              attribute="Mp4 URL"
              :placeholder="$t('frontend_groovevideo_videos_eg_mp4')"
            />
            <gd-button
              size="auto"
              class="py-4 mt-6 px-8 mr-2"
              @click="mp4VideoLink"
            >
              {{ $t('frontend_save') }}
            </gd-button>
          </div>
          <!-- <div
            class="
              absolute
              bottom-0
              left-0
              w-full
              flex
              justify-center
              item-center
              bg-pink
              rounded-br rounded-bl
              p-2
            "
          >
            <p class="text-white text-sm">
              {{ $t('frontend_groovevideo_videos_getfree_access') }}
              <gd-button
                size="large"
                class="text-center bg-white upgradeBtn ml-2"
              >
                {{ $t('frontend_groovevideo_videos_upgrade_pro') }}
              </gd-button>
            </p>
          </div> -->
        </div>
        <div v-if="video.video_source" class="w-full flex justify-center">
          <gd-button primary class="" @click="sendBack">
            {{ $t('frontend_cancel') }}
          </gd-button>
        </div>
      </div>
      <div
        class="dz-preview dz-file-preview outputDisplay"
        v-if="displayUploadbox"
      >
        <div class="w-full text-center p-4">
          <div class="preview">
            <div class="c100 m-auto pink" :class="'p' + uploadProgressStatus">
              <span>{{ uploadProgressStatus }} %</span>
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>
            <h6 class="mt-3 w-full inline-block">
              {{ $t('frontend_groovevideo_videos_uploading') }}
            </h6>
            <p class="mt-2">
              {{ $t('frontend_groovevideo_videos_wait_until') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- No storage added modal -->
    <add-storage-modal ref="addStorageModal"/>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { fetchActivity } from '@/api/index.js';
import Loading from 'vue-loading-overlay';
import themeConfig from '@/theme/themeConfig.js';
import Swal from 'sweetalert2';
import Auth from '@groovepages/gd-lib/auth';
import axios from 'axios';
import SourceType from '@/models/SourceType.js';
import { required, url, minLength, maxLength } from 'vuelidate/lib/validators';
import Category from '@/models/Category';
import Video from '@/models/Video';
import AddStorageModal from '@/components/AddStorageModal';

export default {
  components: {
    vueDropzone: vue2Dropzone,
    AddStorageModal
  },
  props: {
    storageId: {
      default() {
        return 0;
      },
    },
    storageFolder: {
      default() {
        return 0;
      },
    },
    encoderId: {
      default() {
        return 0;
      },
    },
    storage: {
      default() {
        return [];
      },
    },
    isPaid: {
      type: Boolean,
      default() {
        return {};
      },
    },
    headers: {},
    maxSize: {},
    videoDetails: {},
  },
  data() {
    return {
      model: '',
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      files: [],
      user: null,
      newActivity: {
        status: '',
        msg: '',
      },
      usedData: [],
      isEnabled: 1,
      uploadProgressStatus: 0,
      btnVisible: '',
      categories: [],
      video: {
        name: this.$t('frontend_groovevideo_name_of_video'),
        category_id: 1,
      },
      awss3: {
        signingURL: `${window.config.apiUrl}/get-signing-url`,
        headers: {},
        params: {
          storageId: this.storageId,
        },
        sendFileToServer: false,
        withCredentials: false,
      },
      dropzoneOptions: {
        acceptedFiles: '.mp4,.webm,.flv',
        url: `${window.config.apiUrl}/upload`,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      currentTab: 'step1',
      uploadTabs: [
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_mycomputer'),
          value: 'step1',
        },
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_youtube'),
          value: 'step2',
        },
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_link'),
          value: 'step3',
        },
      ],
      model: {
        youtubeUrl: '',
        mp4Url: '',
      },
      displayUploadbox: false,
      nextButtonDisabled: true,
      video_source_type: [],
      temporaryBucket: null,
      fetchingTempBucket: true
    };
  },

  computed: {
    canUploadVideos() {
      return !this.isPaid && (this.storageId > 0 && this.encoderId > 0 && this.storageFolder !== 0);
    }
  },
  validations: {
    video: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      category_id: {
        required,
      },
    },
    model: {
      youtubeUrl: {
        required,
        url,
      },
      mp4Url: {
        required,
        url,
      },
    },
  },

  mounted() {
    this.url = `${window.config.apiUrl}/upload`;
    this.user = this.$store.state.user.id;
    if (this.videoDetails) {
      this.video = this.videoDetails;

      if (this.videoDetails.video_source_type === 2) {
        this.model.youtubeUrl = this.videoDetails.video_source;
        this.currentTab = 'step2';
      } else if (this.videoDetails.video_source_type === 3) {
        this.model.mp4Url = this.videoDetails.video_source;
        this.currentTab = 'step3';
      }
    }
  },
  async created() {
    this.showLoader();
    // Get video categories
    const category = await Category.$get();
    this.temporaryBucket = this.storage && this.storage.temporary_bucket;

    // Set categories
    const self = this;
    category.forEach((value, index) => {
      self.categories.push({ text: value.category, value: value.id });
    });
    this.hideLoader();

    // Setting temporary bucket details
    if(this.storage.id && !this.temporaryBucket) {
      const storage = (await axios.post('create-temp-bucket', {
        storageId: this.storageId,
      })).data.data;

      this.temporaryBucket = storage && storage.temporary_bucket;
    }
    this.fetchingTempBucket = false;
  },
  methods: {
    sendBack() {
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: this.$route.params.id },
      });
    },
    openUpgradeModal() {
      this.$refs.addStorageModal.open();
    },
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    validateForm() {
      this.$v.video.$touch();
      const isValid = !this.$v.video.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    s3UploadError(errorMessage) {
      const self = this;
      self.hideLoader();
      self.newActivity = 'failed';
      self.createActivity();
      self.$refs.myVueDropzone.enable();
      self.isEnabled = 1;
    },
    uploadProgress(file, progress, bytesSent) {
      this.uploadProgressStatus = progress;
      this.uploadProgressStatus = Math.round(this.uploadProgressStatus);
    },
    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      console.log(totaluploadprogress, totalBytes, totalBytesSent);
    },
    fileAdded(file) {
      const fileSize = (file.size / (1000 * 1000)).toFixed(1);

      // Validate
      const isValid = this.validateForm();

      // Max File Size Check
      if (fileSize > this.maxSize) {
        // Remove file in case greater than allowed file size
        this.$refs.myVueDropzone.removeFile(file);

        // Show error message
        Swal.fire(
          'Uplaod Error',
          `Files larger than ${this.maxSize}MB are not allowed.`,
          'error'
        );
      } else if (!isValid) {
        // Remove file in case invalid fields
        this.$refs.myVueDropzone.removeFile(file);
      } else {
        const self = this;
        // Timeout lets added file to get queued for processing
        setTimeout(() => {
          // Check queued file
          if (self.$refs.myVueDropzone.getQueuedFiles().length) { 
            const element = self.$el.querySelector('#customdropzone');
            if (element.classList.contains('dz-started')) {
              self.displayUploadbox = true;
            }
            // Initiate file upload
            self.$refs.myVueDropzone.processQueue();
          }
        }, 300);
      }
    },
    async s3UploadSuccess(s3ObjectLocation) {
      const self = this;
      const files = self.$refs.myVueDropzone.getAcceptedFiles();
      if (files.length) {
        const fileSize = files[0].size;

        const allowedUsers = [
          '5f0d5d4a6ca1bd0016c5142f',
          '9d280130-6f1d-429a-8231-b7d77de8c3c4',
        ];

        const currentUserAllowed = allowedUsers.includes(this.user);

        // Creating video if it doesnot already exist
        if (!this.video.id) {
          await this.createVideo();
        }
        var video = document.createElement('video');
        video.preload = 'metadata';
        video.src = URL.createObjectURL(files[0]);
        let [duration, videoHeight, videoWidth] = [0, 0, 0];

        video.addEventListener('loadedmetadata', async (e) => {
          video = e.path[0];
          window.URL.revokeObjectURL(video.src);
          duration = video.duration;
          videoHeight = video.videoHeight;
          videoWidth = video.videoWidth;
        });

        setTimeout(async () => {        
          const s3UploadSuccessData = await axios.post(
            currentUserAllowed ? 's3upload' : '/upload',
            {
              vid: self.video.id,
              vName: self.video.name,
              vCategory: self.video.category_id,
              storageId: self.storageId,
              encoderId: self.encoderId,
              folder: self.storageFolder,
              isPaid: self.isPaid,
              fileLink: s3ObjectLocation,
              duration: duration,
              videoHeight: videoHeight,
              videoWidth: videoWidth,
              fileSize,
            },{
            headers: {
              'email': this.$store.state.user.email, 
              'apiKey': this.$store.state.user.api_key
            }
          });

          const uploadResponse = s3UploadSuccessData.data;
          console.log('---------', uploadResponse);
          if (uploadResponse.status == 'uploading') {
            self.newActivity = 'uploading';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else if (uploadResponse.status == 'encoding') {
            self.$refs.myVueDropzone.disable();
            self.isEnabled = 0;
            self.hideLoader();
            self.newActivity = 'encoding';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else if (uploadResponse.status == 'uploaded') {
            self.$refs.myVueDropzone.disable();
            self.isEnabled = 0;
            self.hideLoader();
            self.newActivity = 'uploaded';
            this.btnVisible = 'progress100';
            this.nextButtonDisabled = false;
            self.createActivity();
            this.addVideo();
          } else {
            self.hideLoader();
            self.newActivity = 'failed';
            this.btnVisible = 'progress100';
            self.createActivity();
            self.$refs.myVueDropzone.removeAllFiles();
            self.$refs.myVueDropzone.enable();
            self.isEnabled = 1;
          }
        }, 500);
      }
    },

    async createVideo() {
      // Create Video
      const video = new Video({
        name: this.video.name,
        category: this.video.category_id,
      });
      this.video = (await video.save()).data;
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    createActivity() {
      this.$emit('activityCreated', this.newActivity);
    },

    startUploading() {
      if (
        this.$refs.myVueDropzone.getAcceptedFiles().length > 0 &&
        this.isEnabled
      ) {
        this.showLoader();
        this.$refs.myVueDropzone.processQueue();
      }
    },

    addVideo() {
      // Redirect only when button is active
      if (!this.nextButtonDisabled) {
        this.$router.push({
          name: 'AddNewVideo',
          params: {
            id: this.video.id,
            activityCreated: this.newActivity,
          },
        });
      }
    },
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },

    // Get duration of file
    async getFileDurationFromUrl(videoUrl) {
      const videoElement = document.createElement('video');
      videoElement.src = videoUrl;

      return new Promise((resolve) => {
        const timer = setInterval(() => {
          if (videoElement.readyState === 4) {
            // Set duration
            const getTime = videoElement.duration;
            resolve(getTime);
            clearInterval(timer);
          }
        }, 500);
      });
    },

    async mp4VideoLink() {
      this.$v.model.mp4Url.$touch();
      if (!this.$v.model.mp4Url.$invalid) {
        this.showLoader();

        // Creating video if it doesnot already exist
        if (!this.video.id) {
          await this.createVideo();
        }

        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.video.id;
        this.video_source_type.type = 3;
        this.video_source_type.source = this.model.mp4Url;
        this.video_source_type.name = this.video.name;
        this.video_source_type.category = this.video.category_id;
        // Get duration of mp4 URL
        const duration = await this.getFileDurationFromUrl(this.model.mp4Url);
        if (typeof duration === 'number' && duration > 0) {
          this.video_source_type.duration = Math.floor(duration);
        }

        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({
              name: 'AddNewVideo',
              params: { id: this.video.id, mode: 'Mp4' },
            });
          }
        });
      }
    },
    async youtubeVideoLink() {
      this.$v.model.youtubeUrl.$touch();
      if (!this.$v.model.youtubeUrl.$invalid) {
        this.showLoader();

        // Creating video
        if (!this.video.id) {
          await this.createVideo();
        }

        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.video.id;
        this.video_source_type.type = 2;
        this.video_source_type.source = this.model.youtubeUrl;
        this.video_source_type.name = this.video.name;
        this.video_source_type.category = this.video.category_id;

        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({
              name: 'AddNewVideo',
              params: { id: this.video.id, mode: 'youtube' },
            });
          }
        });
      }
    },
  },
};
</script>

<style>
@import '../assets/css/progressbar.css';
#customdropzone .dz-preview .dz-details {
  color: white;
  background-color: #fd6481 !important;
  transition: opacity 0.2s linear;
  text-align: center;
}

.upload.videouploadLoader .dz-message {
  margin: 0;
}

.upload.videouploadLoader {
  width: 372px;
  margin: 0 auto;
}

#customdropzone {
  border: 0;
  background: transparent;
  padding: 0;
}

#customdropzone h3 {
  font-size: 20px !important;
  color: #191d3a;
}

#customdropzone {
  text-align: center !important;
}
.upload.videouploadLoader .vue-dropzone .dz-preview {
  display: none !important;
}
.upload.videouploadLoader .vue-dropzone + .dz-preview.outputDisplay {
  display: none !important;
}

.upload.videouploadLoader .vue-dropzone.dz-started + .dz-preview.outputDisplay {
  display: inline-block !important;
}

.dz-progress {
  width: 60px !important;
  height: 60px !important;
  background-color: transparent;
  border-radius: 50% !important;
  display: inline-block;
  border-color: #989ab2;
  border-width: 5px;
  border-style: solid;
}

.upload.videouploadLoader .bgcolor {
  background: #f3f3f5;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 1 !important;
}

.videouploadLoader .dz-preview h6 {
  color: #191d3a;
  font-size: 20px !important;
}
.videouploadLoader .dz-preview p {
  color: #989ab2;
  font-size: 14px;
}

.videouploadLoader .dropzone .dz-preview {
  margin: 0;
  width: 100%;
  height: 100%;
}

.nextbtn,
.nextbtn:hover {
  background: #d5d8e5;
}

.nextbtn.progress100 {
  background: #ea3d5e;
}
.upgradeBtn {
  border-color: white !important;
}

.dz-preview.dz-file-preview.uploadMsg {
  display: inline-block !important;
}
</style>
